export default __webpack_public_path__ + "static/media/help.bf4c355a.png";